import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAddBookMarkPayload } from '../../../entity/interface/iBookmark';
import { IBookmarkRepository } from '../../repositories/interfaces/iBookmarkRepository';
import { APIPath } from '@intigral/constant';
import ResponseError from '../../entities/errors/ResponseError';

export interface IAddBookmarkUseCase {
    execute(
        apikey: string,
        profileGuid: string,
        payload: IAddBookMarkPayload,
        token: string,
        identityToken: string,
        isGamificationEnabled?: boolean
    ): Promise<boolean>;
}
export class AddBookmarkUseCase implements IAddBookmarkUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get addBookmark(): IBookmarkRepository {
        return container.resolve<IBookmarkRepository>(DI.REPOSITORIES.IBookmarkRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        apikey: string,
        profileGuid: string,
        payload: IAddBookMarkPayload,
        token: string,
        identityToken: string,
        isGamificationEnabled = false
    ): Promise<boolean> {
        // If gamification is enabled, validate required fields
        if (isGamificationEnabled) {
            if (!payload.epochMs || !payload.requestId || !payload.token || !payload.segments) {
                throw new ResponseError(
                    { url: APIPath.BOOKMARK_API },
                    {
                        code: 400,
                        message: 'Missing required gamification fields',
                    }
                );
            }
        }

        const response = await this.addBookmark.addBookmark(apikey, profileGuid, payload, token, identityToken);
        if (typeof response.data !== 'undefined') {
            return true;
        }
        if (typeof response.error !== 'undefined') {
            throw new ResponseError(
                { url: APIPath.BOOKMARK_API },
                {
                    code: response.error.code || 0,
                    message: response.error.msg || 'Unknown error',
                }
            );
        }
        return false;
    }
}
